[
  {
    "id": "TG-E7P-L206-001",
    "module": "TijdGeld",
    "difficulty": 206,
    "question": "Valuta: 1 euro = 1,10 dollar. Je koopt iets van 55 dollar. Hoeveel euro is dat?",
    "options": ["€ 50,00", "€ 60,50", "€ 55,00", "€ 45,00"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "valuta",
    "familyId": "TG-VALUTA",
    "explanation": "1 euro = 1,10 dollar. Om van dollar naar euro te gaan, deel je door 1,10. 55 : 1,10 = 50 euro.",
    "distractorExplanations": {
      "1": "Je vermenigvuldigde 55 met 1,10 (= 60,50). Maar je moet delen: van dollar naar euro is delen door de wisselkoers.",
      "2": "Je hield het bedrag gelijk. Maar 1 euro is meer waard dan 1 dollar, dus je hebt minder euro's nodig.",
      "3": "Je trok 10 euro af in plaats van te delen door 1,10. Gebruik de wisselkoers: 55 : 1,10 = 50."
    }
  },
  {
    "id": "TG-E7P-L206-002",
    "module": "TijdGeld",
    "difficulty": 206,
    "question": "Je belegt € 1000 tegen 5% rente. Na een jaar haal je de rente eraf, maar laat je de 1000 staan. Hoeveel rente heb je na 5 jaar totaal ontvangen?",
    "options": ["€ 250", "€ 50", "€ 276", "€ 200"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-RENTE-5JAAR",
    "explanation": "Je haalt de rente elk jaar eraf, dus het blijft steeds 5% van € 1.000. Dat is € 50 per jaar. Na 5 jaar: 5 × 50 = € 250.",
    "distractorExplanations": {
      "1": "€ 50 is de rente van maar 1 jaar. Na 5 jaar is het 5 × 50 = € 250.",
      "2": "€ 276 zou het zijn bij rente op rente (samengestelde interest). Maar hier haal je de rente elk jaar eraf, dus het is enkelvoudige rente.",
      "3": "€ 200 is de rente van 4 jaar. De vraag is na 5 jaar: 5 × 50 = € 250."
    }
  },
  {
    "id": "TG-E7P-L206-003",
    "module": "TijdGeld",
    "difficulty": 206,
    "question": "Een klok loopt elke dag 2 minuten voor. Na hoeveel dagen loopt hij 1 uur voor?",
    "options": ["30 dagen", "60 dagen", "15 dagen", "20 dagen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-KLOK-VOOR",
    "explanation": "1 uur = 60 minuten. De klok loopt 2 minuten per dag voor. 60 : 2 = 30 dagen.",
    "distractorExplanations": {
      "1": "Bij 60 dagen zou de klok 60 × 2 = 120 minuten = 2 uur voorlopen. Dat is te veel.",
      "2": "Bij 15 dagen loopt de klok 15 × 2 = 30 minuten voor. Dat is maar een half uur.",
      "3": "Bij 20 dagen loopt de klok 20 × 2 = 40 minuten voor. Dat is nog geen uur."
    }
  },
  {
    "id": "TG-E7P-L206-004",
    "module": "TijdGeld",
    "difficulty": 206,
    "question": "BTW berekenen: Een prijs is € 121 inclusief 21% BTW. Wat is de prijs exclusief BTW?",
    "options": ["€ 100", "€ 100,83", "€ 95,60", "€ 121"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "btw",
    "familyId": "TG-BTW-TERUG",
    "explanation": "€ 121 is 121% van de oorspronkelijke prijs (100% + 21% BTW). Dus: 121 : 1,21 = € 100.",
    "distractorExplanations": {
      "1": "Je berekende 21% van 121 (= 25,41) en trok dat af (121 - 25,41 ≈ 95,59). Maar 21% BTW is berekend over de prijs exclusief BTW, niet over 121. Je moet delen door 1,21.",
      "2": "Je rekende met een ander percentage of maakte een deelfout. De juiste berekening: 121 : 1,21 = 100.",
      "3": "€ 121 is de prijs inclusief BTW. De vraag is wat de prijs exclusief BTW is — die is lager."
    }
  },
  {
    "id": "TG-E7P-L206-005",
    "module": "TijdGeld",
    "difficulty": 206,
    "question": "Hoeveel milliseconden in 5 minuten?",
    "options": ["300.000", "30.000", "5.000", "300"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-MIN-MS",
    "explanation": "Eerst minuten naar seconden: 5 × 60 = 300 seconden. Dan seconden naar milliseconden: 300 × 1.000 = 300.000 ms.",
    "distractorExplanations": {
      "1": "Je mist een nul. 300 seconden × 1.000 = 300.000, niet 30.000. Je vermenigvuldigde waarschijnlijk met 100 in plaats van 1.000.",
      "2": "5.000 is 5 × 1.000. Je vergat de stap van minuten naar seconden (× 60). Eerst omrekenen naar seconden!",
      "3": "300 is het aantal seconden in 5 minuten. Je moet nog vermenigvuldigen met 1.000 om milliseconden te krijgen."
    }
  }
]